/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DidacticFunctionInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class DidacticFunctionApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'DidacticFunctions');
  }

  find(params?): Observable<DidacticFunctionInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<DidacticFunctionInterface[]>(path, httpParams);
  }

  getDidacticFunctions(params: HttpParams): Observable<{ count: number; results: DidacticFunctionInterface[] }> {
    return this.get<{
      count: number;
      results: DidacticFunctionInterface[];
    }>('search', params);
  }

  deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<void>(path).pipe(map(() => true));
  }

  createDidacticFunction(didacticFunction: DidacticFunctionInterface): Observable<DidacticFunctionInterface> {
    const path = '';
    return this.post<DidacticFunctionInterface>(path, undefined, didacticFunction);
  }

  updateDidacticFunction(
    params: HttpParams,
    didacticFunction: DidacticFunctionInterface
  ): Observable<DidacticFunctionInterface> {
    const path = '';
    return this.put<DidacticFunctionInterface>(path, params, didacticFunction);
  }
}
